<div class="dropdown" style="padding-left: 10px">
	<button
		class="dropdown-toggle download-button"
		type="button"
		[attr.aria-expanded]="dropdownOpen"
		(click)="dropdownOpen = !dropdownOpen; $event.stopPropagation()">
		<span class="download-badge tw-bg-gray-500 tw-text-white tw-rounded-full tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-mr-2">{{ totalNotes || 0 }}</span>
		<i *ngIf="loading" class="fa fa-spinner fa-spin tw-mr-2"></i>
		<i *ngIf="!loading" class="fa fa-download tw-mr-2"></i>
		<span class="tw-text-black">{{ text }}</span>
		<i class="fa fa-chevron-down download-chevron tw-ml-2" [class.rotated]="dropdownOpen"></i>
	</button>
	<div
		*ngIf="dropdownOpen"
		class="dropdown-menu"
		(click)="$event.stopPropagation()">
		<button class="dropdown-item" type="button" (click)="downloadStudentNote(this.id, 'csv'); $event.stopPropagation()">
			<i class="fa fa-file-excel-o tw-text-green-600" aria-hidden="true"></i> Download as CSV
		</button>
		<button class="dropdown-item" type="button" (click)="downloadStudentNote(this.id, 'xlsx'); $event.stopPropagation()">
			<i class="fa fa-file-excel-o tw-text-blue-600" aria-hidden="true"></i> Download as XLSX
		</button>
	</div>
</div>
